import noScroll from "@/utils/noScroll.js";

// Виджет вешается на саму мобильную шапку и управляет:
// сендвичем-переключателем меню, закрытием меню при открытии заявки
// и скрытием шапки при скролле вниз.
export default function mobileHeader(header, data) {
    const menu = document.getElementById(data.menuId || "mobile-menu");
    const burger = header.querySelector(".mobile-header-burger");

    if (!menu || !burger) {
        return;
    }

    let isOpen = false;

    function openMenu() {
        if (isOpen) {
            return;
        }
        isOpen = true;
        menu.classList.add("open");
        header.classList.add("menu-open");
        header.classList.remove("hidden");
        noScroll.hideScroll();
    }

    function closeMenu() {
        if (!isOpen) {
            return;
        }
        isOpen = false;
        menu.classList.remove("open");
        header.classList.remove("menu-open");
        noScroll.showScroll();
    }

    burger.addEventListener("click", function () {
        isOpen ? closeMenu() : openMenu();
    });

    // Клик по затемнённому фону шторки закрывает меню
    menu.addEventListener("click", function (event) {
        if (event.target === menu) {
            closeMenu();
        }
    });

    // Заявка из шапки открывается поверх — меню при этом прячем
    window.addEventListener("openRequestPopup", closeMenu);

    // Порог, ниже которого мелкие подрагивания скролла игнорируем
    const threshold = parseInt(data.scrollThreshold) || 5;
    let lastY = window.scrollY;
    let ticking = false;

    function updateOnScroll() {
        ticking = false;

        const y = window.scrollY;
        const delta = y - lastY;

        if (Math.abs(delta) < threshold) {
            return;
        }

        // При открытом меню и у самого верха шапку не трогаем
        if (!isOpen && y > header.offsetHeight) {
            header.classList.toggle("hidden", delta > 0);
        } else {
            header.classList.remove("hidden");
        }

        lastY = y;
    }

    window.addEventListener(
        "scroll",
        function () {
            if (!ticking) {
                window.requestAnimationFrame(updateOnScroll);
                ticking = true;
            }
        },
        { passive: true }
    );
}
